import _Clear from "@material-ui/icons/esm/Clear";
import _isEqual from "lodash/isEqual";
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? Object(arguments[i]) : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys.push.apply(ownKeys, Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
import React, { Component } from 'react';
import { fullWhite } from 'material-ui/styles/colors';
import classnames from 'classnames';
import { MEDIA_TYPES, DEFAULT_ZINDEX } from 'swag-client-common/utils/constants';
import Logo from '../logo';
import Text from '../text';
import { scaleLogoOnMouseMove, getRotationAngle, isRectangleSame, scaleTextOnMouseMove, calculateLogoSizeInPercentage } from './media-editor.utils';
import classes from './media-editor.scss';
export class MediaEditorComponent extends Component {
  constructor(...args) {
    // @ts-ignore
    super(...args);
    _defineProperty(this, "logoImageRef", void 0);
    _defineProperty(this, "rotating", void 0);
    _defineProperty(this, "moving", void 0);
    _defineProperty(this, "mousePositionBeforeResize", void 0);
    _defineProperty(this, "logoRectangleBeforeResize", void 0);
    _defineProperty(this, "scaling", void 0);
    _defineProperty(this, "imprintAreaRectangle", void 0);
    _defineProperty(this, "mousePosition", void 0);
    _defineProperty(this, "logoRectangleBeforeRotate", void 0);
    const {
      media: {
        rect,
        fontSize
      },
      view
    } = this.props;
    this.onDocMouseTouchMove = this.onDocMouseTouchMove.bind(this);
    this.onDocMouseTouchEnd = this.onDocMouseTouchEnd.bind(this);
    this.onMoveMouseTouchDown = this.onMoveMouseTouchDown.bind(this);
    this.onScaleMouseTouchDown = this.onScaleMouseTouchDown.bind(this);
    this.onRotateMouseTouchDown = this.onRotateMouseTouchDown.bind(this);
    this.handleLogoLoad = this.handleLogoLoad.bind(this);
    this.moving = false;
    this.scaling = false;
    this.rotating = false;
    this.state = {
      logoRect: rect,
      view,
      fontSize,
      isModifying: false
    };
  }
  componentDidMount() {
    const {
      handleLogoDeleted
    } = this.props;
    document.addEventListener('mousemove', this.onDocMouseTouchMove);
    document.addEventListener('touchmove', this.onDocMouseTouchMove);
    document.addEventListener('mouseup', this.onDocMouseTouchEnd);
    document.addEventListener('touchend', this.onDocMouseTouchEnd);
    document.addEventListener('touchcancel', this.onDocMouseTouchEnd);
    handleLogoDeleted(false);
  }
  componentWillUnmount() {
    const {
      handleLogoDeleted
    } = this.props;
    document.removeEventListener('mousemove', this.onDocMouseTouchMove);
    document.removeEventListener('touchmove', this.onDocMouseTouchMove);
    document.removeEventListener('mouseup', this.onDocMouseTouchEnd);
    document.removeEventListener('touchend', this.onDocMouseTouchEnd);
    document.removeEventListener('touchcancel', this.onDocMouseTouchEnd);
    handleLogoDeleted(true);
  }
  UNSAFE_componentWillReceiveProps(nextProps) {
    if (this.moving || this.scaling || this.rotating) {
      return;
    }
    const {
      logoRect,
      fontSize
    } = this.state;
    const stateDiff = {};
    if (!isRectangleSame(logoRect, nextProps.media.rect)) {
      stateDiff.logoRect = nextProps.media.rect;
    }
    if (fontSize !== nextProps.media.fontSize) {
      stateDiff.fontSize = nextProps.media.fontSize;
    }
    this.setState(stateDiff);
  }
  componentDidUpdate(prevProp) {
    const {
      logoRect,
      fontSize
    } = this.state;
    const {
      media: {
        inscription
      },
      mediaId,
      type,
      imprintAreaRef,
      onDimensionsChange
    } = this.props;
    if (prevProp.media.inscription !== inscription && imprintAreaRef && this.logoImageRef && type === MEDIA_TYPES.TEXTS && prevProp.type === MEDIA_TYPES.TEXTS) {
      const imprintAreaRectangle = imprintAreaRef.getBoundingClientRect();
      const logoRectangleBeforeResize = this.logoImageRef.getBoundingClientRect();
      const rect = calculateLogoSizeInPercentage(logoRectangleBeforeResize, imprintAreaRectangle);
      if (!isNaN(rect.width) && !isNaN(rect.height)) {
        onDimensionsChange({
          rect: _objectSpread({}, logoRect, rect, {
            fontSize
          }),
          mediaId,
          type
        });
      }
    }
  }
  onDocMouseTouchMove(e) {
    if (!(this.moving || this.scaling || this.rotating)) {
      return;
    }
    e.preventDefault();
    const mousePosition = this.getClientPos(e);
    if (this.moving) {
      this.moveMedia(mousePosition);
    }
    if (this.scaling) {
      this.scaleMedia(mousePosition);
    }
    if (this.rotating) {
      this.rotateMedia(mousePosition);
    }
    this.mousePosition = _objectSpread({}, this.mousePosition, {
      clientX: mousePosition.x,
      clientY: mousePosition.y
    });
  }
  onDocMouseTouchEnd() {
    const {
      onDimensionsChange,
      mediaId,
      onLogoInteract,
      media: {
        inscription,
        rect,
        preview
      },
      type
    } = this.props;
    const textSrc = !!inscription;
    const {
      fontSize,
      logoRect
    } = this.state;
    this.moving = false;
    this.scaling = false;
    this.rotating = false;
    this.setState({
      isModifying: false
    });
    const logoRectHaveChanged = !_isEqual(logoRect, rect);
    if (textSrc && logoRectHaveChanged) {
      onDimensionsChange({
        rect: _objectSpread({}, logoRect, {
          fontSize
        }),
        mediaId,
        type
      });
    }
    if (preview && logoRectHaveChanged) {
      onDimensionsChange({
        rect: _objectSpread({}, logoRect),
        mediaId,
        type
      });
    }
    onLogoInteract(false);
  }
  moveMedia(pos) {
    const {
      logoRect
    } = this.state;
    const {
      onLogoInteract
    } = this.props;
    const rectClientRect = this.imprintAreaRectangle;
    const move = {
      left: (pos.x - this.mousePosition.clientX || 0) / rectClientRect.width,
      top: (pos.y - this.mousePosition.clientY || 0) / rectClientRect.height
    };
    const top = logoRect.top + move.top * 100;
    const left = logoRect.left + move.left * 100;
    this.setState({
      logoRect: _objectSpread({}, logoRect, {
        top,
        left
      })
    });
    onLogoInteract(true);
  }
  scaleMedia(currentMousePosition) {
    const {
      logoRect,
      logoRect: {
        angle
      }
    } = this.state;
    const {
      onLogoInteract,
      media: {
        fontSize
      },
      type
    } = this.props;
    const isTextTypeMedia = type === MEDIA_TYPES.TEXTS;
    const scaleMediaInfo = {
      fontSize,
      currentMousePosition,
      mediaRotationAngle: angle,
      initialMediaPercentageParams: logoRect,
      initialMousePosition: this.mousePositionBeforeResize,
      initialMediaPixelParams: this.logoRectangleBeforeResize,
      imprintAreaPixelParams: this.imprintAreaRectangle
    };
    if (isTextTypeMedia) {
      const {
        fontSize: scaledFontSize,
        width,
        height
      } = scaleTextOnMouseMove(scaleMediaInfo);
      return this.setState({
        fontSize: Math.round(scaledFontSize),
        logoRect: _objectSpread({}, logoRect, {
          width,
          height
        })
      });
    }
    const newLogoRectangle = scaleLogoOnMouseMove(scaleMediaInfo);
    this.setState({
      logoRect: newLogoRectangle
    });
    onLogoInteract(true);
  }
  rotateMedia(mousePosition) {
    const {
      logoRect
    } = this.state;
    const {
      onLogoInteract
    } = this.props;
    const halfOfLogoWidth = this.logoRectangleBeforeRotate.width / 2;
    const halfOfLogoHeight = this.logoRectangleBeforeRotate.height / 2;
    const logoCenterPosition = {
      x: halfOfLogoWidth + this.logoRectangleBeforeRotate.left,
      y: halfOfLogoHeight + this.logoRectangleBeforeRotate.top
    };
    const nonRotatedPixelParams = this.getNonRotatedPixelParams();
    const angle = getRotationAngle(mousePosition, logoCenterPosition, nonRotatedPixelParams);
    this.setState({
      logoRect: _objectSpread({}, logoRect, {
        angle
      })
    });
    onLogoInteract(true);
  }
  getNonRotatedPixelParams() {
    const {
      type
    } = this.props;
    const {
      logoRect
    } = this.state;
    const isTextTypeMedia = type === MEDIA_TYPES.TEXTS;
    if (isTextTypeMedia) {
      return this.logoImageRef.getBoundingClientRect();
    }
    return {
      width: this.imprintAreaRectangle.width * logoRect.width,
      height: this.imprintAreaRectangle.height * logoRect.height
    };
  }
  onGeneralMouseDown(e) {
    e.preventDefault(); // Stop drag selection.
    e.stopPropagation();
    const {
      imprintAreaRef,
      onLogoSelect,
      mediaId
    } = this.props;
    this.imprintAreaRectangle = imprintAreaRef.getBoundingClientRect();
    onLogoSelect(mediaId);
    const mousePosition = this.getClientPos(e);
    this.mousePosition = {
      clientX: mousePosition.x,
      clientY: mousePosition.y
    };
  }
  onRotateMouseTouchDown(e) {
    this.onGeneralMouseDown(e);
    this.logoRectangleBeforeRotate = this.logoImageRef.getBoundingClientRect();
    this.setState({
      isModifying: true
    });
    this.rotating = true;
  }
  onMoveMouseTouchDown(e) {
    e.preventDefault(); // Stop drag selection.

    this.setState({
      isModifying: true
    });
    this.onGeneralMouseDown(e);
    this.moving = true;
  }
  onScaleMouseTouchDown(e) {
    this.onGeneralMouseDown(e);
    this.mousePositionBeforeResize = this.getClientPos(e);
    this.logoRectangleBeforeResize = this.logoImageRef.getBoundingClientRect();
    this.setState({
      isModifying: true
    });
    this.scaling = true;
  }
  getStyles() {
    const {
      logoRect
    } = this.state;
    const {
      type,
      layer
    } = this.props;
    const styles = {};
    if (logoRect) {
      const {
        top,
        left,
        width,
        height,
        angle
      } = logoRect;
      styles.logoRect = {
        top: `${top}%`,
        left: `${left}%`,
        width: width && `${width}%`,
        height: height && `${height}%`,
        transform: `rotate(${angle || 0}deg)`,
        zIndex: DEFAULT_ZINDEX + layer
      };
    }
    if (type === MEDIA_TYPES.TEXTS) {
      delete styles.logoRect.width;
      delete styles.logoRect.height;
    }
    return styles;
  }
  getClientPos(e) {
    if (['touchmove', 'touchend', 'touchcancel', 'touchstart'].includes(e.type)) {
      return {
        x: e.targetTouches[0].clientX,
        y: e.targetTouches[0].clientY
      };
    }
    return {
      x: e.clientX,
      y: e.clientY
    };
  }
  handleLogoLoad() {
    const {
      onLogoLoad,
      logoAreaStyle,
      mediaId,
      showDebossedPopup,
      showLaserEngravedPopup,
      shouldShowDebossedPopupInCaseEmbellishmentMethodIsOnlyDebossed,
      shouldShowLaserEngravedPopupInCaseEmbellishmentMethodIsOnlyLaserEngraved,
      productId
    } = this.props;
    onLogoLoad(this.logoImageRef, logoAreaStyle, mediaId);
    if (shouldShowDebossedPopupInCaseEmbellishmentMethodIsOnlyDebossed) {
      showDebossedPopup(productId);
    }
    if (shouldShowLaserEngravedPopupInCaseEmbellishmentMethodIsOnlyLaserEngraved) {
      showLaserEngravedPopup(productId);
    }
  }
  render() {
    const {
      mediaId,
      media,
      selectedLogo,
      onLogoDelete,
      onSendBackwardLayer,
      onBringForwardLayer,
      showLayerButton,
      type,
      onCloseTextDialog,
      isFullScreenMode,
      showRemoveButton,
      showLogoControls,
      isLimitedEdition
    } = this.props;
    const {
      fontSize,
      isModifying
    } = this.state;
    const {
      colors,
      inscription,
      rect,
      fontFamily,
      color,
      preview
    } = media;
    const logoColors = colors && colors.colorsToPrint;
    const isActive = selectedLogo === mediaId;
    const isControlShown = (preview || inscription) && showLogoControls;
    const logoHasNoDimensions = !rect;
    const isTextTypeMedia = type === MEDIA_TYPES.TEXTS;
    const styles = this.getStyles();
    return /*#__PURE__*/React.createElement("div", {
      className: classnames({
        [classes.hidden]: logoHasNoDimensions
      }),
      "data-block": "Image"
    }, isModifying && /*#__PURE__*/React.createElement("div", {
      className: classnames(classes.bottomLabel, {
        [classes.orangeBackground]: isLimitedEdition
      })
    }, "Print area"), /*#__PURE__*/React.createElement("div", {
      className: classnames({
        [classes.withBackground]: isModifying,
        [classes.withOrangeBackground]: isModifying && isLimitedEdition
      }, classes.visibleArea)
    }, isTextTypeMedia && /*#__PURE__*/React.createElement(Text, {
      mediaId: mediaId,
      getRef: el => {
        this.logoImageRef = el;
      },
      inscription: inscription,
      onClick: onCloseTextDialog,
      styles: _objectSpread({
        color,
        fontSize: isFullScreenMode && fontSize * 1.5 || fontSize,
        fontFamily: fontFamily && `"${fontFamily.name}"`,
        textOverflow: 'initial'
      }, styles.logoRect)
    }) || /*#__PURE__*/React.createElement(Logo, {
      getRef: el => {
        this.logoImageRef = el;
      },
      logoSrc: preview,
      logoColors: logoColors,
      styles: styles.logoRect,
      onLogoLoad: this.handleLogoLoad
    })), isControlShown && /*#__PURE__*/React.createElement("div", {
      className: classnames(classes.logo, {
        [classes.isActive]: isActive
      }),
      "data-block": "Controls",
      style: styles.logoRect,
      onMouseDown: this.onMoveMouseTouchDown,
      onTouchStart: this.onMoveMouseTouchDown
    }, fontFamily && /*#__PURE__*/React.createElement("div", {
      className: classes.hiddenText,
      style: _objectSpread({}, styles.logoRect, {
        fontSize: isFullScreenMode && fontSize * 1.5 || fontSize,
        fontFamily: `"${fontFamily.name}"`
      })
    }, inscription), /*#__PURE__*/React.createElement("div", {
      className: classnames(classes.lineT, {
        [classes.active]: isActive,
        [classes.withoutLayerButtonLineT]: !showLayerButton,
        [classes.withoutRemoveButtonLineT]: showLayerButton && !showRemoveButton,
        [classes.fullWidthLine]: !showRemoveButton && !showLayerButton
      })
    }), /*#__PURE__*/React.createElement("div", {
      className: classnames(classes.lineL, {
        [classes.active]: isActive,
        [classes.withoutLayerButtonLineL]: !showLayerButton
      })
    }), /*#__PURE__*/React.createElement("div", {
      className: classnames(classes.lineR, {
        [classes.active]: isActive,
        [classes.withoutLayerButtonLineL]: !showRemoveButton
      })
    }), /*#__PURE__*/React.createElement("div", {
      className: classnames(classes.lineB, {
        [classes.active]: isActive
      })
    }), /*#__PURE__*/React.createElement("div", {
      className: classnames(classes.controls, {
        [classes.active]: isActive
      })
    }, /*#__PURE__*/React.createElement("div", {
      className: classnames(classes.drag, {
        [classes.orangeBackground]: isLimitedEdition
      }),
      "data-button": "Drag",
      onMouseDown: this.onScaleMouseTouchDown,
      onTouchStart: this.onScaleMouseTouchDown
    }), showRemoveButton && /*#__PURE__*/React.createElement(_Clear, {
      onClick: () => onLogoDelete(mediaId),
      className: classes.close,
      htmlColor: fullWhite,
      "data-button": "Close"
    }), /*#__PURE__*/React.createElement("div", {
      className: classnames(classes.rotate, {
        [classes.orangeBackground]: isLimitedEdition
      }),
      "data-button": "Rotate",
      onMouseDown: this.onRotateMouseTouchDown,
      onTouchStart: this.onRotateMouseTouchDown
    }), showLayerButton && /*#__PURE__*/React.createElement("div", {
      className: classnames(classes.layer, {
        [classes.orangeBackground]: isLimitedEdition
      }),
      "data-button": "Layer"
    }, /*#__PURE__*/React.createElement("div", {
      className: classes.layerOptions
    }, /*#__PURE__*/React.createElement("div", {
      className: classnames(classes.optionItem, {
        [classes.orangeColor]: isLimitedEdition
      }),
      onClick: () => onBringForwardLayer(mediaId),
      "data-item": "Forward"
    }, "Bring forward"), /*#__PURE__*/React.createElement("div", {
      className: classnames(classes.optionItem, {
        [classes.orangeColor]: isLimitedEdition
      }),
      onClick: () => onSendBackwardLayer(mediaId),
      "data-item": "Backward"
    }, "Send backward"))))));
  }
}